/**
 * Track an event via Heap analytics.
 *
 * Safe to call server-side (SSR), without Heap loaded (adblock, tests), and
 * never throws — analytics must not break the user flow.
 *
 * @param {string} event  - Event name, e.g. "File Added from Library"
 * @param {Record<string, any>} [properties] - Optional event properties
 */
export function track(event, properties) {
    try {
        if (typeof window !== 'undefined') {
            window.heap?.track(event, properties);
        }
    } catch {
        // ignore analytics failures
    }
}

/**
 * Attach properties to the identified Heap user. Same safety guarantees as `track`.
 *
 * @param {Record<string, any>} properties
 */
export function addUserProperties(properties) {
    try {
        if (typeof window !== 'undefined') {
            window.heap?.addUserProperties(properties);
        }
    } catch {
        // ignore analytics failures
    }
}
